import type React from "react";
import {Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";

type TaxonomyDeleteCategoryDialogProps = {
    label: string;
    /** Every category below it, any depth: they are removed with it. */
    descendantCount: number;
    isSaving: boolean;
    onCancel: () => void;
    onConfirm: () => void;
};

/** Confirms deleting a category together with its whole branch. */
export const TaxonomyDeleteCategoryDialog: React.FC<TaxonomyDeleteCategoryDialogProps> = ({
                                                                                              label,
                                                                                              descendantCount,
                                                                                              isSaving,
                                                                                              onCancel,
                                                                                              onConfirm,
                                                                                          }) => (
    <Dialog open onClose={isSaving ? undefined : onCancel} maxWidth="xs" fullWidth>
        <DialogTitle>Delete category</DialogTitle>
        <DialogContent>
            <DialogContentText>
                Are you sure you want to delete <Box component="strong" sx={{color: 'text.primary'}}>{label}</Box>
                {descendantCount > 0
                    ? <> and its {descendantCount} {descendantCount === 1 ? 'sub-category' : 'sub-categories'}?</>
                    : '?'}
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button onClick={onCancel} disabled={isSaving}>Cancel</Button>
            <Button variant="contained" color="error" onClick={onConfirm} disabled={isSaving}>
                {isSaving ? 'Deleting…' : 'Delete'}
            </Button>
        </DialogActions>
    </Dialog>
);
